import api from "./api";

const IS_DEV = typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production";

/**
 * Fire a phone_call_clicked event.
 * Non-blocking — errors are logged but never throw (a tel: link must always work).
 */
export function trackPhoneCall(cta_location) {
  const payload = {
    event: "phone_call_clicked",
    cta_location,
    page: typeof window !== "undefined" ? window.location.pathname : "",
    device: getDeviceType(),
    referrer: typeof document !== "undefined" ? document.referrer : "",
  };
  try {
    api.post("/analytics/events", payload).catch((err) => {
      if (IS_DEV) console.warn("[analytics] event post failed", err?.message);
    });
  } catch (err) {
    if (IS_DEV) console.warn("[analytics] tracking failed", err);
  }
  if (IS_DEV) {
    console.debug("[analytics]", payload);
  }
}

function getDeviceType() {
  if (typeof navigator === "undefined") return "unknown";
  const ua = navigator.userAgent || "";
  if (/mobile/i.test(ua)) return "mobile";
  if (/tablet|ipad/i.test(ua)) return "tablet";
  return "desktop";
}

/**
 * Generic event tracker for conversion analytics.
 * Used by Schedule Consultation CTA, exit-intent modal, quiz completions, etc.
 * Non-blocking — errors are logged but never throw.
 */
export function trackEvent(event, extra = {}) {
  const payload = {
    event,
    ...extra,
    page: typeof window !== "undefined" ? window.location.pathname : "",
    device: getDeviceType(),
    referrer: typeof document !== "undefined" ? document.referrer : "",
  };
  try {
    api.post("/analytics/events", payload).catch((err) => {
      if (IS_DEV) console.warn("[analytics] event post failed", err?.message);
    });
  } catch (err) {
    if (IS_DEV) console.warn("[analytics] tracking failed", err);
  }
  if (IS_DEV) {
    console.debug("[analytics]", payload);
  }
}
